import { render, staticRenderFns } from "./Trading.vue?vue&type=template&id=0bd0583f&scoped=true&"
import script from "./Trading.vue?vue&type=script&lang=js&"
export * from "./Trading.vue?vue&type=script&lang=js&"
import style0 from "./Trading.vue?vue&type=style&index=0&id=0bd0583f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd0583f",
  null
  
)

export default component.exports